<div
  class="journey-contact-phone-strip"
  [class.is-ready]="variant === 'ready'"
  [class.is-proof]="variant === 'proof'"
  [class.is-fair]="variant === 'fair'"
  [class.is-needed]="!displayPhone || nudgeVisible"
  [class.is-nudge]="nudgeVisible"
  [class.is-invalid]="status === 'invalid'">
  <p class="journey-contact-phone-title" *ngIf="title">{{ title }}</p>

  <div class="journey-ready-setup-field">
    <div class="journey-ready-setup-label-row">
      <label class="journey-ready-setup-label" [attr.for]="inputId">{{ label }}</label>
      <ng-container *ngIf="showStatusPills">
        <span class="journey-ready-setup-pill" *ngIf="!displayPhone">Recommended</span>
        <span
          class="journey-ready-setup-pill is-done"
          *ngIf="displayPhone && status !== 'saving' && status !== 'saved'">Saved</span>
      </ng-container>
      <span class="journey-ready-setup-meta" *ngIf="status === 'saving'">Saving…</span>
      <span class="journey-ready-setup-meta" *ngIf="status === 'saved'">Saved</span>
    </div>

    <div class="journey-phone-control" [class.is-focused]="phoneRowFocused">
      <mat-select
        class="journey-phone-dial"
        panelClass="journey-phone-dial-panel"
        [ngModel]="dialCode"
        (ngModelChange)="onDialChange($event)"
        [disabled]="status === 'saving'"
        aria-label="Country code"
        (openedChange)="phoneRowFocused = $event"
        disableOptionCentering>
        <mat-select-trigger>
          <span class="journey-phone-dial-trigger">{{ dialDisplay }}</span>
        </mat-select-trigger>
        <mat-option *ngFor="let c of countries" [value]="c.dialCode">
          {{ c.code }} {{ c.dialCode }} — {{ c.name }}
        </mat-option>
      </mat-select>
      <span class="journey-phone-divider" aria-hidden="true"></span>
      <input
        #phoneInput
        [id]="inputId"
        type="tel"
        class="journey-phone-national"
        [ngModel]="national"
        (ngModelChange)="onNationalChange($event)"
        name="journeyContactNational"
        maxlength="14"
        placeholder="Mobile number"
        autocomplete="tel-national"
        inputmode="numeric"
        [attr.aria-invalid]="status === 'invalid'"
        [readonly]="status === 'saving'"
        (focus)="onFocus(); phoneRowFocused = true"
        (blur)="phoneRowFocused = false; commitFromEdit()"
        (keydown.enter)="$event.preventDefault(); commitFromEdit()"
        (keydown.escape)="$event.preventDefault(); cancelEdit()" />
    </div>

    <p class="journey-ready-setup-hint" *ngIf="status !== 'invalid' && hint">
      {{ hint }}
    </p>
    <p class="journey-ready-setup-error" *ngIf="status === 'invalid'">
      Enter a valid mobile number for the selected country.
    </p>
    <div class="journey-ready-phone-nudge" *ngIf="nudgeVisible">
      <p class="journey-ready-phone-nudge-copy">{{ nudgeCopy }}</p>
      <button
        type="button"
        class="journey-link journey-ready-phone-nudge-skip"
        (click)="skip()">
        {{ skipLabel || 'Continue without a number' }}
      </button>
    </div>
    <button
      type="button"
      class="journey-link journey-contact-phone-skip"
      *ngIf="showSkip && !nudgeVisible"
      (click)="skip()">
      {{ skipLabel }}
    </button>
  </div>
</div>
